import{defineMessages}from'react-intl';

export default defineMessages({
button:{
id:'i18n.alert_modal.button',
defaultMessage:'Close'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0FsZXJ0TW9kYWwvQWxlcnRNb2RhbC5tZXNzYWdlcy5qcyJdLCJuYW1lcyI6WyJkZWZpbmVNZXNzYWdlcyIsImJ1dHRvbiIsImlkIiwiZGVmYXVsdE1lc3NhZ2UiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLE9BQVE7QUFDTkMsR0FBSSx5QkFERTtBQUVOQyxlQUFnQixPQUZWLENBRG9CLENBQWYsQ0FBZiIsImZpbGUiOiJBbGVydE1vZGFsLm1lc3NhZ2VzLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBkZWZpbmVNZXNzYWdlcyB9IGZyb20gJ3JlYWN0LWludGwnO1xuXG5leHBvcnQgZGVmYXVsdCBkZWZpbmVNZXNzYWdlcyh7XG4gIGJ1dHRvbjoge1xuICAgIGlkOiAnaTE4bi5hbGVydF9tb2RhbC5idXR0b24nLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnQ2xvc2UnLFxuICB9LFxufSk7XG5cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/components/AlertModal/AlertModal.messages.js
// module id = 2031
// module chunks = 0